import { Navigate } from 'react-router-dom';
import type { ReactNode } from 'react';
import { useSellerAuth } from '../context/SellerAuthContext.js';

export function ProtectedRoute({ children }: { children: ReactNode }) {
  const { accessToken } = useSellerAuth();
  if (!accessToken) return <Navigate to="/login" replace />;
  return <>{children}</>;
}
